import AccountWrapper from './AccountWrapper'
import { routes as vUserRoutes, ROUTES as USER_ROUTES } from './user/router'
import { routes as vTeamRoleRoutes, ROUTES as TEAM_ROLE_ROUTES } from './team-role/router'

const ROUTES = {
  CHANGE_PASSWORD: 'user-change-password',
  CHANGE_EMAIL: 'user-change-email',
  ...USER_ROUTES,
  ...TEAM_ROLE_ROUTES
}

const routes = [
  {
    path: 'account/',
    component: AccountWrapper,
    name: 'ticket-wrapper',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'change-password',
        name: ROUTES.CHANGE_PASSWORD,
        component: () => import('../auth/ChangePassword')
      },
      {
        path: 'change-email',
        name: ROUTES.CHANGE_EMAIL,
        component: () => import('../auth/ChangeEmail')
      },
      ...vUserRoutes,
      ...vTeamRoleRoutes
    ]
  }
]

export { routes, ROUTES }
